import React from "react";
import {Route} from "react-router-dom";
import NewInstitutionContainer from "../../pages/maintenance/institution/newInstitution/NewInstitutionContainer";
import {
    EDIT_INSTRUMENT_ROUTE,
    INSERT_CONTACT_ROUTE,
    INSERT_INSTITUTION_ROUTE,
    INSERT_SIGN_ROUTE,
    MAINTENANCE_AFORO_ROUTE,
    MODIFY_INSTITUTION_SCHEDULE_ROUTE,
    UPDATE_INSTITUTION_ROUTE,
    UPDATE_USER_ROUTE,
    USER_PERMISSIONS_ROUTE,
} from "../../utils/constants/RoutesConstants";
import ContactContainer from "../../pages/maintenance/institution/contact/ContactContainer";
import SignContainer from "../../pages/maintenance/institution/sign/SignContainer";
import UpdateInstitutionContainer
    from "../../pages/maintenance/institution/updateInstitution/UpdateInstitutionContainer";
import ModifyInstitutionSchedule from "../../pages/maintenance/schedule/modifyInstitutionSchedule"
import UpdateUser from "../../pages/maintenance/users/updateUser";
import UserPermissions from "../../pages/maintenance/users/permissions";
import Aforo from "../../pages/aforo";
import EditInstrument from "../../pages/maintenance/instrument/editInstrument";


const MaintenanceRoutes = () => {
    return (
        <React.Fragment>
            <Route path={INSERT_INSTITUTION_ROUTE} component={NewInstitutionContainer}/>
            <Route path={UPDATE_INSTITUTION_ROUTE} component={UpdateInstitutionContainer}/>
            <Route path={INSERT_CONTACT_ROUTE} component={ContactContainer}/>
            <Route path={INSERT_SIGN_ROUTE} component={SignContainer}/>
            <Route path={MODIFY_INSTITUTION_SCHEDULE_ROUTE} component={ModifyInstitutionSchedule}/>
            <Route path={UPDATE_USER_ROUTE} component={UpdateUser}/>
            <Route path={USER_PERMISSIONS_ROUTE} component={UserPermissions}/>
            <Route path={MAINTENANCE_AFORO_ROUTE} component={Aforo}/>
            <Route path={EDIT_INSTRUMENT_ROUTE} component={EditInstrument}/>
        </React.Fragment>
    );
};

export default MaintenanceRoutes;